<template>
  <div id="app" class="min-h-screen bg-isp-page text-isp-primary">
    <RouterView />
    <!-- Único renderer de los notify.* (store `notification`); vive aquí para cubrir también /login. -->
    <IspToastContainer />
  </div>
</template>

<script setup lang="ts">
import { RouterView } from 'vue-router'
import IspToastContainer from '@/components/ui/feedback/IspToastContainer.vue'
</script>
